import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
// @mui
import { Box, Divider, MenuItem, Stack } from '@mui/material';
// hooks
import useLocales from '../../../hooks/useLocales';
// components
import Image from '../../../components/Image';
import { useSelector } from '../../../redux/store';
import CustomModal from '../../../components/CustomModal';

// ----------------------------------------------------------------------

LanguagePopover.propTypes = {
  CustomBtn: PropTypes.any,
  PopoverProps: PropTypes.object,
};

export default function LanguagePopover({ CustomBtn, PopoverProps = {} }) {
  const { allLangs, currentLang, onChangeLang } = useLocales();

  const { siteSettings } = useSelector((x) => x.lookup);

  const [customLangs, setCustomLangs] = useState([]);

  const [open, setOpen] = useState(null);

  const [selectedLang, setSelectedLang] = useState(currentLang);

  const { translate } = useLocales();

  const domainLocale = process.env.REACT_APP_LOCALE;

  const langStorage = localStorage.getItem('i18nextLng');

  useEffect(() => {
    // setCustomLangs(allLangs.filter((f) => f.value === 'en' || f.value === domainLocale));
    if (siteSettings?.languages?.length > 0) {
      // const matchingLangs = allLangs.filter((obj1) =>
      //   siteSettings?.languages.some((obj2) => obj1.value === obj2.locale)
      // );

      const matchingLangs = allLangs;

      if (matchingLangs) {
        setCustomLangs(matchingLangs);

        if (matchingLangs.findIndex((ml) => ml.value === langStorage) === -1) {
          handleChangeLang(matchingLangs.find((f) => f.value === domainLocale)?.value);
          console.log('matching');
        }
      } else {
        console.log('No Matching languages');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [siteSettings?.languages]);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleChangeLang = (newLang) => {
    // localStorage.setItem('i18nextLng', newLang);
    onChangeLang(newLang);
    handleClose();
    window.location.reload();
  };

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }} onClick={(e) => handleOpen(e)}>
        {/* <Image
          src={require('../../../assets/home/language.png')}
          sx={{ height: '30px', width: '30px', cursor: 'pointer' }}
        /> */}
        <Box sx={{ flex: 1 }}>
          {CustomBtn ? (
            React.cloneElement(CustomBtn, { title: selectedLang?.label })
          ) : (
            <Image
              disabledEffect
              src={selectedLang.icon}
              alt={selectedLang.label}
              sx={{ width: { xs: 25, sm: 35 }, height: { xs: 25, sm: 35 } }}
            />
            // <Button
            //   variant={'text'}
            //   // onClick={handleOpen}
            //   startIcon={
            //     <Image disabledEffect src={selectedLang.icon} alt={selectedLang.label} sx={{ width: 28, height: 20 }} />
            //   }
            //   sx={sx}
            //   size="small"
            // >
            //   <Typography fontWeight={700} color={'#21592E'}>{selectedLang.value?.toUpperCase()}</Typography>
            // </Button>
          )}
        </Box>
      </Box>

      <CustomModal
        open={Boolean(open)}
        onClose={handleClose}
        title={translate('change_language')}
        PaperProps={{
          sx: {
            color: '#000',
            background: '#fff',
            width: 500,
          },
        }}
        {...PopoverProps}
      >
        <Divider sx={{ borderBottomWidth: '2px' }} />

        <Box
          sx={{
            my: 1,
            mx: 2,
            height: 'fit-content',
            '& .MuiMenuItem-root': { px: 1, typography: 'body2', borderRadius: 0.75 },
          }}
        >
          <Stack spacing={0.75}>
            {customLangs.map((option) => (
              <MenuItem
                key={option.value}
                selected={option.value === currentLang.value}
                onClick={() => {
                  handleChangeLang(option.value);
                  setSelectedLang(option);
                }}
                sx={{ color: '#000' }}
              >
                <Image disabledEffect alt={option.label} src={option.icon} sx={{ width: 35, height: 35, mr: 2 }} />

                {option.label}
              </MenuItem>
            ))}
          </Stack>
        </Box>
      </CustomModal>
    </>
  );
}
